export default __webpack_public_path__ + "static/media/pro.554ff6bd.png";